import { render, staticRenderFns } from "./ObjectTree.vue?vue&type=template&id=35ba12b0&scoped=true"
import script from "./ObjectTree.vue?vue&type=script&lang=js"
export * from "./ObjectTree.vue?vue&type=script&lang=js"
import style0 from "./ObjectTree.vue?vue&type=style&index=0&id=35ba12b0&prod&lang=css"
import style1 from "./ObjectTree.vue?vue&type=style&index=1&id=35ba12b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ba12b0",
  null
  
)

export default component.exports